import * as angular from "angular";
import {BringozToastService} from "../../commons/services/bringoz-toast.service";

export class SkillsAlerts {

  /* @ngInject */
  constructor(private bringozToastService: BringozToastService) {
  }

  // ******************************
  //        Public methods
  // ******************************

  // GET_ALL //
  getAllError() {
    const message = {
      body: 'SKILLS_GET_ALL_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // CREATE //
  createSuccess() {
    const message = {
      body: 'SKILL_CREATE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  createError() {
    const message = {
      body: 'SKILL_CREATE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // UPDATE //
  updateOneSuccess(skill) {
    const message = {
      body: 'X_SKILL_UPDATE_ONE_SUCCESS'
    };
    return this.bringozToastService.success(message, {name: skill.name})
  }

  updateOneError() {
    const message = {
      body: 'SKILL_UPDATE_ONE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // UPDATE ACTIVE //
  updateActiveOneSuccess(skill) {
    const message = {
      body: skill.active ? 'X_SKILL_UPDATE_ENABLED_ONE_SUCCESS' : 'X_SKILL_UPDATE_DISABLED_ONE_SUCCESS'
    };
    return this.bringozToastService.success(message, {name: skill.name})
  }

  updateActiveOneError(isEnable) {
    const message = {
      body: isEnable ? 'X_SKILL_UPDATE_ENABLED_ONE_ERROR' : 'X_SKILL_UPDATE_DISABLED_ONE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }


}

angular
  .module('bringoz.admin.skills')
  .service('skillsAlerts', SkillsAlerts);
